import React, { useEffect, useState } from "react";

import commonFunction from "../../../../lib/utils/common";
import search_type_const from "../../../../lib/utils/hotel/constants.json";
import { invalidAlphanumeric } from "../../../../lib/utils/regex_cheat_sheet";
// import styles from "./index.module.css";

export default function HotelAutoComplete(props) {
 
  let mainArray = [];

  let recentSearchList = [];
  if (props?.userProfile && props?.userProfile?.status) {
    // Logged in: use API data
    recentSearchList = Array.isArray(props.getrecentSearchList)
      ? props.getrecentSearchList.filter(x => x && x.destination_id)
      : [];
  } else {
    // Not logged in: use localStorage
    try {
      const localRecent = JSON.parse(localStorage.getItem("hotel_recent_search"));
      recentSearchList = Array.isArray(localRecent)
        ? localRecent.filter(x => x && x.destination_id)
        : [];
    } catch {
      recentSearchList = [];
    }
  }

  // Remove recent searches from suggestions to avoid duplicates
  // const recentIds = new Set(recentSearchList.map(x => x.destination_id));
  // let autoSuggestList = Array.isArray(props.autoCompleteData)
  //   ? props.autoCompleteData.filter(x => !recentIds.has(x.destination_id))
  //   : [];


   let autoSuggestList = Array.isArray(props.autoCompleteData) ? props.autoCompleteData : [];
  
  // Sort suggestions to prioritize exact matches and main cities
  if (autoSuggestList.length > 0) {
    autoSuggestList = autoSuggestList.sort((a, b) => {
      const searchText = props.value?.toLowerCase() || '';
      const aText = a.search_text?.toLowerCase() || '';
      const bText = b.search_text?.toLowerCase() || '';
      
      // Exact match gets highest priority
      const aExactMatch = aText === searchText;
      const bExactMatch = bText === searchText;
      if (aExactMatch && !bExactMatch) return -1;
      if (!aExactMatch && bExactMatch) return 1;
      
      // Check if search text is at the beginning of the city name
      const aCityNameMatch = aText.toLowerCase().startsWith(searchText);
      const bCityNameMatch = bText.toLowerCase().startsWith(searchText);
      if (aCityNameMatch && !bCityNameMatch) return -1;
      if (!aCityNameMatch && bCityNameMatch) return 1;
      
      // Main city (search_type: 6) gets priority over other types
      const aIsCity = a.search_type === 6 || a.search_type === "6";
      const bIsCity = b.search_type === 6 || b.search_type === "6";
      if (aIsCity && !bIsCity) return -1;
      if (!aIsCity && bIsCity) return 1;
      
      // Countries and provinces also get higher priority than airports/hotels
      const aIsRegion = a.search_type === 2 || a.search_type === "2" || a.search_type === 3 || a.search_type === "3";
      const bIsRegion = b.search_type === 2 || b.search_type === "2" || b.search_type === 3 || b.search_type === "3";
      if (aIsRegion && !bIsRegion) return -1;
      if (!aIsRegion && bIsRegion) return 1;
      
      // For cities starting with search term, prioritize by relevance
      const aStartsWith = aText.startsWith(searchText);
      const bStartsWith = bText.startsWith(searchText);
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      
      return 0;
    });
  }


  if (
    recentSearchList &&
    recentSearchList?.length > 0 &&
    autoSuggestList?.length > 0
  ) {
    // Combine auto-suggestions first, then recent searches
    mainArray = [...autoSuggestList, ...recentSearchList];
  } else if (recentSearchList?.length == 0 && autoSuggestList?.length > 0) {
    mainArray = autoSuggestList;
  } else if (recentSearchList?.length > 0 && autoSuggestList?.length == 0) {
    mainArray = recentSearchList;
  }

  // Remove duplicates by destination_id, keeping the first occurrence (which will be from auto-suggestions)
  if (mainArray.length > 0) {
    const seen = new Set();
    mainArray = mainArray.filter(({ destination_id }) => {
      if (seen.has(destination_id)) return false;
      seen.add(destination_id);
      return true;
    });
  }

  function saveRecentSearchForGuest(selectedItem) {
    if (!props?.userProfile || !props?.userProfile?.status) {
      let localRecent = [];
      try {
        localRecent = JSON.parse(localStorage.getItem("hotel_recent_search")) || [];
      } catch {
        localRecent = [];
      }
      // Remove if already exists
      localRecent = localRecent.filter(x => x.destination_id !== selectedItem.destination_id);
      // Add to top
      localRecent.unshift(selectedItem);
      // Limit to 5 or 10 items
      localRecent = localRecent.slice(0, 5);
      // Save back
      localStorage.setItem("hotel_recent_search", JSON.stringify(localRecent));
    }
  }

  return (
    <div className={props?.styles?.hotel_search_wid_inputfield}>
      <label className={props.isMobile ? props?.styles?.hiddenOnMobile : ""}>
        {props.label}
      </label>
      <div className={props?.styles?.hotel_search_wid_inputfield_main}>
       
        <input
          type="text"
          autoComplete={"off"}
          id="hotels_location_input"
          tabIndex="1"
          readOnly
        
          placeholder={
            !commonFunction.isValueEmpty(props.placholder)
              ? props.placholder
              : ""
          }
          className={`${props.styles?.search_widget_input_new} ${
            props.isMobile ? props?.styles?.hiddenOnMobile : ""
          }`}
          value={
            props?.isDetailPage
              ? props?.selectedHotel
              : !commonFunction.isValueEmpty(props.value) &&
                !props.expandAutoCompleteBool
              ? props.value
              : ""
          }
          
          onClick={() => {
            props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
            props.onChangeHotelName("");
            props.onClickHotelInput();
          }}
          disabled={props.disabled}
        />
        {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (
          <div className={props.styles?.hotel_search_error_message}>
            <span>{props.value != "" ? "" : "Enter destination"}</span>
          </div>
        ) : null}
        {/* {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (
          <div className={props.styles?.hotel_search_error_message}>
            <span>
              {props.autoCompleteData.length == 0
                ? "Enter valid destination"
                : ""}
            </span>
          </div>
        ) : null} */}
        {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (  
          <div className={props.styles?.hotel_search_error_message}>
            <span>
              {props.value === "" ? "Enter destination" : 
               (props.autoCompleteData.length === 0 && props.value.length > 2) ? "Enter valid destination" : ""}
            </span>
          </div>
        ) : null}
      {!props.isMobile && props.expandAutoCompleteBool === true ? (
  <div className={props.styles?.autocomp_container} tabIndex="1">
    <div
      className={`${props.styles?.autocomp_countryList} ${props.styles?.hotel_autocomplete_value}`}
    >
      <div className={props.styles?.input_search_destination}>
        <span className={props.styles?.search_icon}>
          <img src="images/eth-search-icon.svg" alt="search" />
        </span>
        <input
          type="text"
          autoComplete={"off"}
          id="hotels_location_input"
          onFocus={props.onInputFocus}
          autoFocus
          onKeyDown={props.onKeyDownArrow}
          placeholder={
            !commonFunction.isValueEmpty(props.placholder)
              ? props.placholder
              : ""
          }
          className={props.styles?.search_widget_input_new}
          value={
            !commonFunction.isValueEmpty(props.value) ? props.value : ""
          }
          onChange={(event) => {
            props.onChangeHotelName(event.target.value);
          }}
          onClick={() => {
            props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
            props.onChangeHotelName("");
            props.onClickHotelInput();
          }}
        />
      </div>

      <div
        className={`${props.styles?.hotel_autocomplete_value} ${props.styles?.hotel_autocompleteMain}`}
        id="hotelDataArray"
      >

        {/* Suggestions - show from mainArray that are auto-suggestions */}
        {mainArray.filter(item => autoSuggestList.some(auto => auto.destination_id === item.destination_id)).length > 0 && (
          <>
            <div className={props.styles.suggestion_label}>Suggestions</div>
            {mainArray
              .filter(item => autoSuggestList.some(auto => auto.destination_id === item.destination_id))
              .map((element) => (
              <div
                key={'suggest-' + element.destination_id}
                className={props.styles.hotel_autocomplete_element}
                onClick={() => {
                  saveRecentSearchForGuest(element);
                  props.onClickHotelName(element);
                  props.isAutoCompleteExpand(false);
                }}
                style={{ paddingTop: 10 }}
              >
                <span className={props.styles.location_icon}>
                  <img src="images/eth_location.svg" alt="location" />
                </span>
                <div className={props.styles.hotel_autocomplete_name}>
                  <div>{element.search_text}</div>
                  <div className={props.styles.hotel_list_flex}>
                    <div className={props.styles.hotel_prop_city}></div>
                    {element.property_count === 0 ? (
                      ""
                    ) : (
                      <div className={props.styles.hotel_autocomplete_tag}>
                        {element.property_count} Properties
                      </div>
                    )}
                  </div>
                </div>
                <div className={props.styles?.hotelnw_city}>
                  {element?.dest_type ? element?.dest_type?.text : " "}
                </div>
              </div>
            ))}
          </>
        )}

        {/* Recent Search Section - show from mainArray that are recent searches */}
        {/* {mainArray.filter(item => recentSearchList.some(recent => recent.destination_id === item.destination_id 
        && !autoSuggestList.some(auto => auto.destination_id === item.destination_id))).length > 0 && 
        ( */}
        {mainArray.filter(item => recentSearchList.some(recent => recent.destination_id === item.destination_id)).length > 0 && (
          <>
            <div className={props.styles.recent_label}>Recent Search</div>
            {/* {mainArray
              .filter(item => recentSearchList.some(recent => recent.destination_id === item.destination_id && !autoSuggestList.some(auto => auto.destination_id === item.destination_id)))
              .map((recelement) => ( */}
              {mainArray
              .filter(item => recentSearchList.some(recent => recent.destination_id === item.destination_id))
              .map((recelement) => (
              <div
                key={'recent-' + recelement.destination_id}
                className={props.styles.hotel_autocomplete_element}
                onClick={() => {
                  saveRecentSearchForGuest(recelement);
                  props.onClickHotelName(recelement);
                  props.isAutoCompleteExpand(false);
                }}
                style={{ paddingTop: 10 }}
              >
                <span className={props.styles.recent_icon}>
                  <img src="images/eth_recent_icon.svg" alt="recent" />
                </span>
                <div className={props.styles.hotel_autocomplete_name}>
                  <div className={props.styles.hotel_autocomplete_city}>
                    {recelement.search_text}
                  </div>
                  <div className={props.styles.hotel_autocomplete_tag}>
                    {recelement.property_count} Properties
                  </div>
                </div>
                <div className={props.styles?.hotelnw_city}>
                  {recelement?.dest_type ? recelement?.dest_type?.text : " "}
                </div>
              </div>
            ))}
          </>
        )}


        {/* No Result Found */}
        {mainArray.length === 0 && (
            <div className={props.styles.no_res}>
              <p>No Result Found</p>
            </div>
          )}
      </div>
    </div>
  </div>
) : null}

{props.isMobile && (
  <div className={props.styles?.autocomp_container} tabIndex="1">
    <div
      className={`${props.styles?.autocomp_countryList} ${props.styles?.hotel_autocomplete_value}`}
      id="hotelDataArray"
    >
      <div className={props.styles?.input_search_destination}>
        <span className={props.styles?.search_icon}>
          <img src="images/eth-search-icon.svg" alt="search" />
        </span>
        <input
          type="text"
          autoComplete={"off"}
          id="hotels_location_input"
          tabIndex="1"
          onFocus={props.onInputFocus}
          autoFocus
          onKeyDown={props.onKeyDownArrow}
          placeholder={
            !commonFunction.isValueEmpty(props.placholder)
              ? props.placholder
              : ""
          }
          className={props.styles?.search_widget_input_new}
          value={
            !commonFunction.isValueEmpty(props.value) ? props.value : ""
          }
          onChange={(event) => {
            const newValue = event.target.value.replace(
              invalidAlphanumeric,
              ""
            );
            props.onChangeHotelName(newValue);
          }}
          onClick={() => {
            props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
            props.onChangeHotelName("");
            props.onClickHotelInput();
          }}
        />
      </div>

      <div
        className={`${props.styles?.hotel_autocomplete_value} ${props.styles?.hotel_autocompleteMain}`}
      >

        {/* Suggestions */}
        {mainArray.filter(item => autoSuggestList.some(auto => auto.destination_id === item.destination_id)).length > 0 && (
          <>
            <div className={props.styles.suggestion_label}>Suggestions</div>
            {mainArray
              .filter(item => autoSuggestList.some(auto => auto.destination_id === item.destination_id))
              .map((element) => (
              <div
                key={'suggest-' + element.destination_id}
                className={props.styles.hotel_autocomplete_element}
                onClick={() => {
                  saveRecentSearchForGuest(element);
                  props.onClickHotelName(element);
                  props.isAutoCompleteExpand(false);
                }}
              >
                <span className={props.styles.location_icon}>
                  <img src="images/eth_location.svg" alt="location" />
                </span>
                <div className={props.styles.hotel_autocomplete_name}>
                  <div className={props.styles.hotel_searchlabel}>
                    {element.search_text}
                  </div>
                  <div className={props.styles.hotel_list_flex}>
                    <div className={props.styles.hotel_prop_city}></div>
                    {element.property_count === 0 ? (
                      ""
                    ) : (
                      <div className={props.styles.hotel_autocomplete_tag}>
                        {element.property_count} Properties
                      </div>
                    )}
                  </div>
                </div>
                <div className={props.styles?.hotelnw_city}>
                  {element?.search_type
                    ? search_type_const.search_type_const[element?.search_type]?.text
                    : " "}
                </div>
              </div>
            ))}
          </>
        )}

        {/* Recent Search */}
        {mainArray.filter(item => recentSearchList.some(recent => recent.destination_id === item.destination_id && !autoSuggestList.some(auto => auto.destination_id === item.destination_id))).length > 0 && (
          <>
            <div className={props.styles.recent_label}>Recent Search</div>
            {mainArray
              .filter(item => recentSearchList.some(recent => recent.destination_id === item.destination_id && !autoSuggestList.some(auto => auto.destination_id === item.destination_id)))
              .map((recelement) => (
              <div
                key={'recent-' + recelement.destination_id}
                className={props.styles.hotel_autocomplete_element}
                onClick={() => {
                  saveRecentSearchForGuest(recelement);
                  props.onClickHotelName(recelement);
                  props.isAutoCompleteExpand(false);
                }}
              >
                <span className={props.styles.recent_icon}>
                  <img src="images/eth_recent_icon.svg" alt="recent" />
                </span>
                <div className={props.styles.hotel_autocomplete_name}>
                  <div className={props.styles.hotel_autocomplete_city}>
                    {recelement.search_text}
                  </div>
                  <div className={props.styles.hotel_autocomplete_tag}>
                    {recelement.property_count} Properties
                  </div>
                </div>
                <div className={props.styles?.hotelnw_city}>
                  {recelement?.dest_type ? recelement?.dest_type?.text : " "}
                </div>
              </div>
            ))}
          </>
        )}

        {/* No Result Found */}
        {mainArray.length === 0 && (
            <div className={props.styles.no_res}>
              <p>No Result Found</p>
            </div>
          )}
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
}
